var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAskDocument({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.23078 1.23077C3.02163 1.23077 1.23077 3.02163 1.23077 5.23078C1.23077 7.43995 3.02163 9.23078 5.23078 9.23078C7.43995 9.23078 9.23078 7.43995 9.23078 5.23078C9.23078 3.02163 7.43995 1.23077 5.23078 1.23077ZM0 5.23078C0 2.3419 2.3419 0 5.23078 0C8.11964 0 10.4616 2.3419 10.4616 5.23078C10.4616 6.45349 10.042 7.57816 9.33909 8.46881L11.8198 10.9495C12.0601 11.1898 12.0601 11.5795 11.8198 11.8198C11.5795 12.0601 11.1898 12.0601 10.9495 11.8198L8.46881 9.33909C7.57816 10.042 6.45349 10.4616 5.23078 10.4616C2.3419 10.4616 0 8.11964 0 5.23078Z",
    fill: "#5D5D5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAskDocument);
export default __webpack_public_path__ + "static/media/askDocument.89f056f084888a2b563b7c3ceba58bc3.svg";
export { ForwardRef as ReactComponent };